import React, { useCallback } from 'react'
import Typography from '@material-ui/core/Typography';
import RouteLinkComponent from './RouteLinkComponent';
import { ROUTES } from '../constants/routes';

const LinkComponent = ({ href, title, className = '', pageLink, extrLink, blank }) => {
    const handlerClick = useCallback(() => {
        document.querySelector('body').style.overflow = 'auto' 
    },[])
    return (
        <>
            {href
                ? <RouteLinkComponent
                    blank={blank}
                    alt={title}
                    to={extrLink ? false : `${pageLink ? ROUTES['page'] : ''}/${href}`}
                    href={extrLink ? href : false}
                >
                    <Typography onClick={handlerClick} variant='body1' color='primary' className={className} >
                        {title}
                    </Typography>
                </RouteLinkComponent>
                : <Typography onClick={handlerClick} variant='body1' color='primary' className={className} >
                    {title}
                </Typography>
            }

        </>
    )
}


export default React.memo(LinkComponent);